import { HttpHeaders } from '@angular/common/http';
import { environment } from '@environment/environment';

export function getHttpHeaders(): HttpHeaders {
  return new HttpHeaders({
    'x-functions-key': environment.apiKey
  });
}
